import { render, staticRenderFns } from "./AfterCall.vue?vue&type=template&id=eb2ae9e4&scoped=true"
import script from "./AfterCall.vue?vue&type=script&lang=js"
export * from "./AfterCall.vue?vue&type=script&lang=js"
import style0 from "./AfterCall.vue?vue&type=style&index=0&id=eb2ae9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2ae9e4",
  null
  
)

export default component.exports